import { Flex, useToken } from '@chakra-ui/react';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { CommonCIQProps, SelectedStyledSystemProps } from 'quotient/types';

type QuotientIllustrationProps = {
  lightIcon: IconDefinition;
  solidIcon: IconDefinition;
  size?: SizeProp;
  solidColor?: string;
  lightColor?: string;
} & SelectedStyledSystemProps &
  CommonCIQProps;

export const QuotientIllustration = ({
  lightIcon,
  solidIcon,
  size = '9x',
  solidColor = 'surfaceBrandActiveLight',
  lightColor = 'surfaceBrandDefault',
  ...rest
}: QuotientIllustrationProps) => {
  const [solidColorToken, lightColorToken] = useToken('colors', [solidColor, lightColor]);
  return (
    <Flex
      alignItems="center"
      className={`fa-layers fa-fw fa-${size}`}
      flexDirection="column"
      gap={3}
      marginTop={6}
      {...rest}
    >
      <FontAwesomeIcon color={solidColorToken} icon={solidIcon} />
      <FontAwesomeIcon color={lightColorToken} icon={lightIcon} transform="up-1 right-1" />
    </Flex>
  );
};
